import React, { useState } from "react";
import classes from "./CardBase.module.scss";
import Card from "@mui/material/Card";
import Slide from "@mui/material/Slide";
import Zoom from "@mui/material/Zoom";

const CardBase = ({
  onClick = null,
  children,
  classPrimary = "",
  type = "base",
  slideDirection,
  transitionDelay,
}) => {
  // const transitionDelay = 100;
  return (
    <>
      {type === "base" && (
        <>
          {!transitionDelay && (
            <Card
              className={`${classes.CardBase} ${classPrimary}`}
              onClick={onClick}
            >
              {children}
            </Card>
          )}
          {transitionDelay && (
            <Zoom in={true} style={{ transitionDelay: `${transitionDelay}ms` }}>
              <Card
                className={`${classes.CardBase} ${classPrimary}`}
                onClick={onClick}
              >
                {children}
              </Card>
            </Zoom>
          )}
        </>
      )}
      {type === "slide" && (
        <Slide direction={slideDirection} in={true} mountOnEnter unmountOnExit>
          <Card
            className={`${classes.CardBase} ${classPrimary}`}
            onClick={onClick}
          >
            {children}
          </Card>
        </Slide>
      )}
    </>
  );
};

export default CardBase;
